var map = {
	"./img-paiming1.svg": "oOE3",
	"./img-paiming2.svg": "csaq",
	"./img-paiming3.svg": "23uE",
	"./img-paiming4.svg": "3Ph0"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Jxzu";


//////////////////
// WEBPACK FOOTER
// ./src/assets/daping ^\.\/img\-paiming.*\.svg$
// module id = Jxzu
// module chunks = 0